module.exports = __webpack_public_path__ + "img/right_zh.0b031c1e.png";